import e from "./index944.js";
var a = e(Object, "create");
export {
  a as default
};
